export default "__VITE_ASSET__DsVcjkB7__"